// Actions
const PREFIX = 'calculus/calculation/';

export const CALCULATION_CALCULATE  = PREFIX + 'CALCULATION_CALCULATE';
export const CALCULATION_LAYER_POSITION  = PREFIX + 'CALCULATION_LAYER_POSITION';
export const CALCULATION_UPDATE  = PREFIX + 'CALCULATION_UPDATE';
export const CALCULATION_PATCH  = PREFIX + 'CALCULATION_PATCH';
export const CALCULATION_PATCH_SECTION  = PREFIX + 'CALCULATION_PATCH_SECTION';

export const CALCULATION_RENAME_REQUEST  = PREFIX + 'CALCULATION_RENAME_REQUEST';
export const CALCULATION_RENAME_CANCEL  = PREFIX + 'CALCULATION_RENAME_CANCEL';
export const CALCULATION_RENAME  = PREFIX + 'CALCULATION_RENAME';

export const CALCULATION_CREATE  = PREFIX + 'CALCULATION_CREATE';
export const CALCULATION_CREATE_REQUEST  = PREFIX + 'CALCULATION_CREATE_REQUEST';
export const CALCULATION_CREATE_CANCEL  = PREFIX + 'CALCULATION_CREATE_CANCEL';

export const CALCULATION_REMOVE_REQUEST  = PREFIX + 'CALCULATION_REMOVE_REQUEST';
export const CALCULATION_REMOVE_CANCEL  = PREFIX + 'CALCULATION_REMOVE_CANCEL';
export const CALCULATION_REMOVE  = PREFIX + 'CALCULATION_REMOVE';
export const CALCULATION_ADD_SECTION  = PREFIX + 'CALCULATION_ADD_SECTION';
export const CALCULATION_REMOVE_SECTION  = PREFIX + 'CALCULATION_REMOVE_SECTION';
export const CALCULATION_CLONE  = PREFIX + 'CALCULATION_CLONE';
export const CALCULATION_CHANGE_TYPE  = PREFIX + 'CALCULATION_CHANGE_TYPE';

export const CALCULATION_ADD_ADAPTER  = PREFIX + 'CALCULATION_ADD_ADAPTER';
export const CALCULATION_REMOVE_ADAPTER  = PREFIX + 'CALCULATION_REMOVE_ADAPTER';
export const CALCULATION_PATCH_ADAPTER  = PREFIX + 'CALCULATION_PATCH_ADAPTER';

export const CALCULATION_UPDATE_RESULTS  = PREFIX + 'CALCULATION_UPDATE_RESULTS';
export const CALCULATION_CALCULATE_RESULTS  = PREFIX + 'CALCULATION_CALCULATE_RESULTS';

export const CALCULATION_TYPE_PLANE  = 'plane';
export const CALCULATION_TYPE_PIPE  = 'pipe';
export const CALCULATION_TYPE_DUCT  = 'duct';
export const CALCULATION_TYPE_TANK  = 'tank';

export const CALCULATION_TYPE_CIRCULAR_DUCT  = 'circular-duct';
export const CALCULATION_TYPE_RECTANGULAR_DUCT  = 'rectangular-duct';

export const CALCULATION_TYPE_VERTICAL_TANK  = 'vertical-tank';
export const CALCULATION_TYPE_HORIZONTAL_TANK  = 'horizontal-tank';
export const CALCULATION_TYPE_RECTANGULAR_TANK  = 'rectangular-tank';

export const CALCULATION_TYPE_MARINE  = 'marine';

export const CALCULATION_TOP_LAYERS  = 'CALCULATION_TOP_LAYERS';
export const CALCULATION_SIDE_LAYERS  = 'CALCULATION_SIDE_LAYERS';
export const CALCULATION_BOTTOM_LAYERS  = 'CALCULATION_BOTTOM_LAYERS';

export const CALCULATION_FLOWRATE_TYPE_KG_TO_S  = 'kg/s';
export const CALCULATION_FLOWRATE_TYPE_M3_TO_H  = 'm³/h';
export const CALCULATION_FLOWRATE_TYPE_L_TO_S  = 'l/s';
export const CALCULATION_FLOWRATE_TYPE_M_TO_S  = 'm/s';

export const INITIAL_STATE = {
  calculateTemperatureChange: false,
  calculateEndTemperature: false,
  calculateSolarRadiation: false,
  flowRateType: CALCULATION_FLOWRATE_TYPE_M_TO_S,

  sectionIndex: 0,
  sections: [],

  calculateEnergyConsumption: false,
  energyType: null,
  energyOperationTime: 8760,
  energyPrice: 5,

  results: null,
  calculating: false,
};

export const SECTION_INITIAL_STATE = {
  thickness: 1,
  type: CALCULATION_TYPE_PLANE,
  width: 200,
  height: 200,
  material: null,
  content: null,
  materialStandard: '-1',

  flowRate: 1,
  klasse: 0,

  calculateFreezing: false,
  calculateAdapters: false,
  calculateSolarRadiation: false,

  environmentType: null,
  environmentTemperature: 0,
  environmentAirVelocity: 0,
  environmentHumidity: 0,

  outerDiameter: 20,
  length: 1,
  freezingPercentage: 25,
  finalTemperature: 80,
  temperature: 100,

  cladding: -2,
  topCladding: -2,
  sideCladding: -2,
  bottomCladding: -2,

  emissivity: 0,
  topEmissivity: 0,
  sideEmissivity: 0,
  bottomEmissivity: 0,

  supportOfCladdingPossible: false,
  supportOfCladding: false,
  influenceOnHeatloss: '0.0035',
  spacersPerM: 2,

  mechanicalFastener: false,
  mechanicalInfluence: '0.0007',
  mechanicalPerM: 5,


  sideValues: {
    top: {
      supportOfCladding: false,
      influenceOnHeatloss: '0.0035',
      spacersPerM: 2,
      mechanicalFastener: false,
      mechanicalInfluence: '0.0007',
      mechanicalPerM: 5,
    },
    side: {
      supportOfCladding: false,
      influenceOnHeatloss: '0.0035',
      spacersPerM: 2,
      mechanicalFastener: false,
      mechanicalInfluence: '0.0007',
      mechanicalPerM: 5,
    },
    bottom: {
      supportOfCladding: false,
      influenceOnHeatloss: '0.0035',
      spacersPerM: 2,
      mechanicalFastener: false,
      mechanicalInfluence: '0.0007',
      mechanicalPerM: 5,
    }
  },

  suspensionOfTarget: false,
  suspensionInfluence: 15,

  heatlossUnitType: 'm',

  selectedLayers: null, // top, side, bottom
  insulationLayers: [],
  topInsulationLayers: null,
  sideInsulationLayers: null,
  bottomInsulationLayers: null,

  topNoInsulation: false,
  sideNoInsulation: false,
  bottomNoInsulation: false,
  noInsulation: false,

  adapters: [],

  results: null,
  calculating: false,
};

export const DEFAULT_ADAPTER = {
  Nid: -1,
  Emissivity: 0.59,
  'Material-thickness': 6.0,
  Material: '2',
  Equivalence: 1.0,
  count: 1,
  insThickness: 50,
  insCoverage: 0,
};

function updateObjectInArray(array, action) {
  return array.map( (item, index) => {
    if(index !== action.index) {
      return item;
    }

    return {
      ...item,
      ...action.item
    };
  });
}

function getSideValueItem(item, section, payload) {
  let selectedLayers = section.selectedLayers;
  if(payload.hasOwnProperty('selectedLayers')) {
    selectedLayers = payload.selectedLayers;
  }

  if(selectedLayers === CALCULATION_TOP_LAYERS) {
    return {
      top: {
        ...section.sideValues.top,
        ...item
      }
    };
  } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
    return {
      side: {
        ...section.sideValues.side,
        ...item
      }
    };
  } else if(selectedLayers === CALCULATION_BOTTOM_LAYERS) {
    return {
      bottom: {
        ...section.sideValues.bottom,
        ...item
      }
    };
  }
}

function getSectionObject(payload, section) {
  let o = {
    ...payload
  };
  if(payload.hasOwnProperty('supportOfCladding')) {
    const item = getSideValueItem({supportOfCladding: payload.supportOfCladding}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }
  if(payload.hasOwnProperty('influenceOnHeatloss')) {
    const item = getSideValueItem({influenceOnHeatloss: payload.influenceOnHeatloss}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }
  if(payload.hasOwnProperty('spacersPerM')) {
    const item = getSideValueItem({spacersPerM: payload.spacersPerM}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }

  if(payload.hasOwnProperty('mechanicalFastener')) {
    const item = getSideValueItem({mechanicalFastener: payload.mechanicalFastener}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }
  if(payload.hasOwnProperty('mechanicalInfluence')) {
    const item = getSideValueItem({mechanicalInfluence: payload.mechanicalInfluence}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }
  if(payload.hasOwnProperty('mechanicalPerM')) {
    const item = getSideValueItem({mechanicalPerM: payload.mechanicalPerM}, section, payload);
    if(item) {
      o = {
        ...o,
        sideValues: {
          ...section.sideValues,
          ...item
        }
      };
    }
  }

//  console.log("...>", o)

  return o;
}

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;
  const { sectionIndex, sections } = state;

  switch (type) {

    case CALCULATION_UPDATE:
      return {
        ...payload
      };

    case CALCULATION_PATCH:
      return {
        ...state,
        ...payload,
      };

    case CALCULATION_PATCH_SECTION:
      const sIndex = payload.hasOwnProperty('sectionIndex') ? payload.sectionIndex : sectionIndex;

      if( payload.hasOwnProperty('tankBase') && (payload.tankBase === 'concrete' || payload.tankBase === 'ground') ) {
        state.sections[sIndex].bottomNoInsulation = true;
        if(state.sections[sIndex].selectedLayers === CALCULATION_BOTTOM_LAYERS) {
          state.sections[sIndex].noInsulation = true;
        }
      }
      if( payload.hasOwnProperty('tankBase') && payload.tankBase === 'legs' ) {
        state.sections[sIndex].bottomNoInsulation = false;
        if(state.sections[sIndex].selectedLayers === CALCULATION_BOTTOM_LAYERS) {
          state.sections[sIndex].noInsulation = false;
        }
      }
      return {
        ...state,
        sections: sections.map((item, index) => {
            if(index !== sIndex && !payload.hasOwnProperty('content') && !payload.hasOwnProperty('temperature')) {
              return item;
            }
            return {
              ...item,
              ...getSectionObject(payload, state.sections[state.sectionIndex])
            };
        })
      };

    case CALCULATION_ADD_SECTION:
      return {
        ...state,
        sections: state.sections.concat({...payload}),
        sectionIndex: state.sections.length
      };

    case CALCULATION_REMOVE_SECTION:

      const newSectionArr = [
        ...state.sections.slice(0, payload.index),
        ...state.sections.slice(payload.index + 1)
      ];

      let newSectionIndex = 0;
      if(newSectionArr[sectionIndex]) {
        newSectionIndex = sectionIndex;
      } else {
        if(newSectionArr[newSectionArr.length - 1]) {
          newSectionIndex = newSectionArr.length - 1;
        }
      }

      return {
        ...state,
        sectionIndex: newSectionIndex,
        sections: newSectionArr
      };

    case CALCULATION_UPDATE_RESULTS:
      return {
        ...state,
        results: payload,
        calculating: false
      };

    case CALCULATION_CALCULATE_RESULTS:
      return {
        ...state,
        calculating: true
      };

    case CALCULATION_RENAME:
      return {
        ...state,
        name: payload.name,
      };

    case CALCULATION_REMOVE_ADAPTER:
    case CALCULATION_ADD_ADAPTER:
    case CALCULATION_PATCH_ADAPTER:
      const addAdapterSectionIndex = payload.hasOwnProperty('sectionIndex') ? payload.sectionIndex : sectionIndex;

      return {
        ...state,
        sections: sections.map((item, index) => {
            if(index !== addAdapterSectionIndex) {
              return item;
            }

            switch (type) {
              case CALCULATION_ADD_ADAPTER:
                return {
                  ...item,
                  adapters: [
                    ...item.adapters,
                    {
                      ...DEFAULT_ADAPTER,
                      ...payload,
                    }
                  ]
                };

              case CALCULATION_PATCH_ADAPTER:
                return {
                  ...item,
                  adapters: item.adapters.map((adapterItem, adapterIndex) => {
                    if(adapterIndex !== payload.index) { return adapterItem; }
                    return {
                      ...adapterItem,
                      ...payload.patch,
                    };
                  }, this)
                };

              case CALCULATION_REMOVE_ADAPTER:
                const calculationAdapterRemoveIndex = item.adapters.indexOf(payload);
                if (calculationAdapterRemoveIndex === -1) {
                  return state;
                }
                return {
                  ...item,
                  adapters: [
                    ...item.adapters.slice(0, calculationAdapterRemoveIndex),
                    ...item.adapters.slice(calculationAdapterRemoveIndex + 1)
                  ]
                };
              default:
                return state;
            }
        })
      };
    default:
      return state;
  }
}

// Action Creators
export function updateCalculation(payload) {
  return {
    type: CALCULATION_UPDATE,
    payload: payload
  };
}

export function patchCalculation(payload) {
  return {
    type: CALCULATION_PATCH,
    payload: payload
  };
}

export function patchCalculationSection(payload) {
  return {
    type: CALCULATION_PATCH_SECTION,
    payload: payload
  };
}


export function insulationLayerPositionChange(payload) {
  return {
    type: CALCULATION_LAYER_POSITION,
    payload: payload
  };
}

export function calculate(payload) {
  return {
    type: CALCULATION_PATCH,
    payload: payload
  };
}

export function createCalculation(payload) {
  return {
    type: CALCULATION_CREATE,
    payload: payload
  };
}

export function requestCreateCalculation(payload) {
  return {
    type: CALCULATION_CREATE_REQUEST,
    payload: payload
  };
}

export function cancelCreateCalculation(payload) {
  return {
    type: CALCULATION_CREATE_CANCEL,
    payload: payload
  };
}

export function changeType(payload) {
  return {
    type: CALCULATION_CHANGE_TYPE,
    payload: payload
  };
}

export function addSection() {
  return {
    type: CALCULATION_ADD_SECTION
  };
}

export function removeSection(payload) {
  return {
    type: CALCULATION_REMOVE_SECTION,
    payload: payload
  };
}

export function cloneCalculation() {
  return {
    type: CALCULATION_CLONE,
  };
}

export function updateResults(payload) {
  return {
    type: CALCULATION_UPDATE_RESULTS,
    payload: payload
  };
}

export function calculateResults() {
  return {
    type: CALCULATION_CALCULATE_RESULTS,
  };
}

export function requestCalculationRename() {
  return {
    type: CALCULATION_RENAME_REQUEST,
  };
}

export function cancelCalculationRename() {
  return {
    type: CALCULATION_RENAME_CANCEL,
  };
}

export function renameCalculation(payload) {
  return {
    type: CALCULATION_RENAME,
    payload: payload
  };
}

export function requestCalculationRemove() {
  return {
    type: CALCULATION_REMOVE_REQUEST,
  };
}

export function cancelCalculationRemove() {
  return {
    type: CALCULATION_REMOVE_CANCEL,
  };
}

export function removeCalculation(payload) {
  return {
    type: CALCULATION_REMOVE,
    payload: payload
  };
}

export function addAdapter(payload) {
  return {
    type: CALCULATION_ADD_ADAPTER,
    payload: payload
  };
}

export function removeAdapter(payload) {
  return {
    type: CALCULATION_REMOVE_ADAPTER,
    payload: payload
  };
}

export function patchAdapter(patch, index) {
  return {
    type: CALCULATION_PATCH_ADAPTER,
    payload: { patch: patch, index: index }
  };
}
